import React from "react";
import Dashboard from "../pages/Dashboard";
import Content from "../pages/Content";
import Analytics from "../pages/Analytics";
import Comments from "../pages/Comments";
import ContentAnalytics from "../pages/ContentAnalytics";
import SponsoredCommunityLayout from "../layouts/SponsoredCommunityLayout";

export const SponsoredCommunityRouter = [
  {
    path: "sponsored-community",
    element: <SponsoredCommunityLayout />,
    children: [
      {
        path: "dashboard/:project_id",
        element: <Dashboard />,
      },
      {
        path: "content/:project_id",
        element: <Content />,
      },
      {
        path: "analytics/:project_id",
        element: <Analytics />,
      },
      {
        path: "comments/:project_id",
        element: <Comments />,
      },
      {
        path: ":page_title/:content_type/:content_id/:project_id",
        element: <ContentAnalytics />,
      },
    ],
  },
];
